import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import Content from './components/welcomeStep/Content'

export const LandingPage = () => {
  const { company } = useCurrentSession()

  useEffect(() => {
    track(trackingEvents.payroll.userLandsInWelcomeOnboarding, {
      companyId: company.id,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Content />
}
